import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusSchedules = () => {
  return (
    <SettingsMetaData propertyName={"Status_Schedules"} viewPropertyName={"Status"} />
  );
};
export default StatusSchedules;